import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  // Load translation using http backend
  .use(HttpApi)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'de',
    
    // Supported languages
    supportedLngs: ['de', 'hr', 'ru'],
    
    // Debug mode (disable in production)
    debug: false,
    
    // Detection options
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'navigator', 'htmlTag'],
      
      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      
      // Cache user language on
      caches: ['localStorage'],
      
      // Optional expire and domain for set cookie
      cookieMinutes: 10080, // 7 days
    },
    
    // Backend options
    backend: {
      // Path where resources get loaded from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      
      // Allow cross domain requests
      crossDomain: true,

      // Cache-busting to force refresh of translations after updates
      queryStringParams: { v: '20260502-2' },
    },
    
    // Resources (we'll load them via HTTP)
    ns: ['common'],
    defaultNS: 'common',
    
    interpolation: {
      // Not needed for react as it escapes by default
      escapeValue: false,
    },
    
    // React i18next special options
    react: {
      // Bind events to load, change language etc
      bindI18n: 'languageChanged',
      
      // Bind events to trigger rerenders
      bindI18nStore: '',
      
      // Set to false if you prefer not to use suspense
      useSuspense: true,
    },
  });

export default i18n;